import { Box, Card, Text } from '@talos/kyoko';
import { OrderTrajectoryChart } from '../../../../OrderTrajectoryChart/OrderTrajectoryChart';
import { usePreTradeTrajectory } from '../../../hooks/usePreTradeTrajectory';
import type { PreTradeResponseData } from '../../../redux/preTradeApi';

interface OrderTrajectoryProps {
  scenario?: PreTradeResponseData;
}

const CHART_HEIGHT = 200;

export function OrderTrajectory({ scenario }: OrderTrajectoryProps) {
  const { analyticsObservable, order, latestAnalytics, predBounds, zoomSubject, handleZoomChange } =
    usePreTradeTrajectory(scenario);

  const noTrajectoryDataState = (
    <Card title="Order Trajectory">
      <Box h="280px" display="flex" alignItems="center" justifyContent="center">
        <Text color="colorTextSubtle">No trajectory data available</Text>
      </Box>
    </Card>
  );

  if (!scenario?.Bins || scenario.Bins.length === 0) {
    return noTrajectoryDataState;
  }

  if (!latestAnalytics) {
    return noTrajectoryDataState;
  }

  return (
    <Card title="Order Trajectory" data-testid="order-trajectory-card">
      <OrderTrajectoryChart
        order={order}
        height={CHART_HEIGHT}
        resizeAware
        latestAnalytics={latestAnalytics}
        legOrParentAnalyticsObservable={analyticsObservable}
        legIndex={1}
        zoomSubject={zoomSubject}
        onZoomChange={handleZoomChange}
        staticBounds={predBounds}
        hideExecQty
      />
    </Card>
  );
}
